import React from 'react'

import { tokenVar } from '../../theme/tokenVar'

export type MapPinIconProps = {
  size?: number
  color?: string
  colorScheme?: 'dark' | 'light'
  className?: string
}

export const MapPinIcon = ({
  size = 20,
  color,
  colorScheme = 'dark',
  className,
}: MapPinIconProps) => {
  const resolvedColor =
    color ??
    (colorScheme === 'light'
      ? tokenVar('colors.light.icon.secondary')
      : tokenVar('colors.icon.secondary'))
  return (
    <svg
      aria-label='Map pin'
      className={className}
      fill='none'
      height={size}
      role='img'
      viewBox='0 0 24 24'
      width={size}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
      <circle
        cx='12'
        cy='10'
        r='3'
        stroke={resolvedColor}
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeWidth={1.5}
      />
    </svg>
  )
}
